const SHORT_OVERVIEW_COUNT = 5;

interface Overview {
  lat: number;
  lng: number;
}

export const getHereRouteSections = (sections: any[]) => sections.map(({ polyline }: any) => {
    // @ts-ignore
    const { polyline: overviewPath } = window.H.util.flexiblePolyline.decode(polyline);

    const shortOverview: Overview[] = [];
    const shift = Math.round(overviewPath.length / SHORT_OVERVIEW_COUNT);

    for(let i = 0; i < overviewPath.length; i += shift) {
      if (overviewPath[i]) {
        shortOverview.push({
          lng: overviewPath[i][1],
          lat: overviewPath[i][0],
        });
      }
    }

    return {
      shortOverview
    };
});
